if (process.env.NODE_ENV === 'production') {
  module.exports = require('./hover.production.js');
} else {
  module.exports = require('./hover.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/hover/dist/es/hover.js
// module id = 1319
// module chunks = 0